import { render, staticRenderFns } from "./AchieveDisplay.vue?vue&type=template&id=0b9cdf60"
import script from "./AchieveDisplay.vue?vue&type=script&lang=js"
export * from "./AchieveDisplay.vue?vue&type=script&lang=js"
import style0 from "./AchieveDisplay.vue?vue&type=style&index=0&id=0b9cdf60&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports